import React from "react";
import { useI18n } from "@/i18n/I18nContext";

const IMAGES = [
  "https://images.unsplash.com/photo-1594424015009-59bef65fa9ec?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1721444694627-8cabea39967e?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1763390097867-02d96b56599a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1699645239349-ef2446b0efb3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1633978077821-6b1b16a176a4?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1777552955794-77aa990a47df?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1629670670137-c0a865ad29ce?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1619096522576-50aa4d3eb277?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  "https://images.unsplash.com/photo-1709662400554-7eed5dc8d906?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
];

export default function GalleryPage() {
  const { t } = useI18n();
  return (
    <main className="min-h-screen" data-testid="gallery-page">
      <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-28 pb-12">
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--brand-primary)] font-bold mb-4">Gallery</p>
        <h1 className="font-display text-stone-900 text-5xl sm:text-7xl tracking-tight">{t("nav_gallery")}</h1>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {IMAGES.map((src, i) => (
            <div key={i} className="mb-5 break-inside-avoid overflow-hidden rounded-2xl bg-stone-100" data-testid={`gallery-img-${i}`}>
              <img src={src} alt="Al Quseir" className="w-full h-auto block hover:scale-105 transition duration-700" loading="lazy" />
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
